import axios from '@/axios'
import helper from './helper'

export default {
  getAll() {
    return helper.get('/events/all')
  },
  update(item) {
    return helper.put(`/events/${ item._id }`, item)
  },
  copy(item) {
    return helper.post(`/events/copy/${ item._id }`, item)
  },
  populateProfile(item) {
    return helper.get(`/admin/populate-profile/${ item._id }`)
  },
  get(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/events/${ id }`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  userevents() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/events`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
